module.exports = __webpack_public_path__ + "img/top-zixun-code.d4dbebc.jpg";